// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1zfSq","header":"ReportDetails_header__32X75","title":"ReportDetails_title__32XyU","left":"ReportDetails_left__2vpzK"};